// src/setup.js - CON PROJECT ID CORRECTO
// CONFIGURACIÓN DE PRODUCCIÓN
window.REACT_APP_APPKIT_PROJECT_ID = "df139799df85ef65e80aa73d82a14195"; // ⭐⭐ ESTE ES TU ID REAL
window.REACT_APP_STRIPE_PUBLISHABLE_KEY = "pk_test_51SnbN7I7wl9Pxb700ZiypAiqO5kiynd5pUf82VF7yMaiZcDmoueIHsCW8t1Usb1HCAmffZwk7RIeWCOVovauZhVH00ZWwWQoXE";
window.REACT_APP_BACKEND_URL = "https://reanimeitor.com/backend";

console.log('✅ Configuración de producción cargada');
console.log('AppKit ID:', window.REACT_APP_APPKIT_PROJECT_ID);